import { render, staticRenderFns } from "./loading-bar.vue?vue&type=template&id=24fe78fc"
import script from "./loading-bar.vue?vue&type=script&lang=js"
export * from "./loading-bar.vue?vue&type=script&lang=js"
import style0 from "./loading-bar.vue?vue&type=style&index=0&id=24fe78fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports